import { Fragment, FunctionComponent } from 'react';
import { Switch } from 'react-router-dom';
import { AudienceDetailsV2 } from '../audienceDetails/components/AudienceDetails_V2';
import { AudienceEditV2 } from '../audienceEdit_v2';
import { PrivateRoute } from '../router/components';
import { AudiencesV2 } from './components/Audiences_v2/AudiencesV2';

const AudiencesRouter: FunctionComponent = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path='/audiences/create' component={AudienceEditV2} />
      <PrivateRoute path='/audiences/:id' component={AudienceDetailsV2} />
      <PrivateRoute path='/audiences' component={AudiencesV2} />
    </Switch>
  </Fragment>
);

export default AudiencesRouter;
